import React, { useContext } from 'react';

//components
import SimpleTable from  '@/components/elements/global/tables/SimpleTable/SimpleTable';
import ArchiveContentModal from  '@/components/modals/content/ArchiveContentModal';

//context
import { ContentListContext } from '../../../context/ListPageContext';
import { ListContext } from '@/context/ListContext';

//interfaces
import { SortType, PaginationSettings } from  '@/interfaces/lists';
import { listTableColumns } from  '@/components/elements/lists/ListConstants';



const ListTable = ({menuItems, sortType, paginationOptions}: {menuItems, sortType: SortType, paginationOptions: PaginationSettings}) => {
    const {formatTableRows, displayMainMenuTable, showArchiveModal, setShowArchiveModal, contentExistsInMultipleLocations, onArchiveItemClick, isLoading} = useContext(ContentListContext)
    const {hasEditorRights} = useContext(ListContext)

    if (!displayMainMenuTable){
        return <></>
    }
    return ( <>
        <SimpleTable 
            simpleTableContent={{columns: listTableColumns, rows: formatTableRows(menuItems)}} 
            isInfiniteScroll={false}
            isPaginated={true}
            noDataMessage='No items to display'
            isDragAndDrop={sortType === SortType.Manual && hasEditorRights}
            paginationInformation={{totalPages: paginationOptions.totalPages, currentPage: paginationOptions.currentPage, resultsPerPage: paginationOptions.pageSize, totalItems: paginationOptions.totalItems}}
            isLoading={isLoading}
       />

        <ArchiveContentModal showModal={!!showArchiveModal} hideModal={() => setShowArchiveModal(null)} contentExistsInMultipleLocations={contentExistsInMultipleLocations} onArchiveItemClick={() => onArchiveItemClick()} />
    </>
    )
}

export default ListTable